import { defineComponent } from 'vue';
export default defineComponent({
    name: 'OkkiTableColumn',
    slots: ['title', 'filterIcon'],
    render() {
        return null;
    },
});
